import React, { useEffect } from "react";
import { Header } from "antd/lib/layout/layout";
import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { isMobileOnly } from "react-device-detect";

const menuItems = [
  {
    key: "presentation",
    label: "Presentation",
  },
  {
    key: "formation",
    label: "Formation",
  },
  {
    key: "competences",
    label: "Competences",
  },

  {
    key: "experiences",
    label: "Experiences",
  },

  {
    key: "realisation",
    label: "Realisation",
  },

  {
    key: "contact",
    label: "Contact",
  },
];

const HeaderApp = () => {
  const location = useLocation();

  useEffect(() => {
    console.log("location", location.pathname);
  });

  return (
    <Header
      style={{
        // position: "fixed",
        zIndex: 1,
        width: "100%",
        // background: "#74BDCB",
        paddingLeft: 65,
      }}
    >
      <a href="/" className="logo">
        <img alt="@hali" width={130} src={logo} />
      </a>

      <MenuLocal location={location} />
    </Header>
  );
};

export const MenuLocal = ({ location }) => {
  const navigate = useNavigate();
  const onMenuClick = (event) => {
    navigate(`/${event.key}`);
  };
  return (
    <Menu
      theme="light"
      mode={isMobileOnly ? "vertical" : "horizontal"}
      defaultSelectedKeys={[location.pathname.split("/")[1] || "presentation"]}
      style={
        isMobileOnly
          ? {}
          : {
              lineHeight: "64px",
              backgroundColor: "transparent",
              marginLeft: "200px",
              color: "white",
            }
      }
      items={menuItems}
      onClick={onMenuClick}
    >
      {/* <Menu.Item key="presentation">
        <Link to="/"> Presentation</Link>
      </Menu.Item>
      <Menu.Item key="formation">
        <Link to="/formation"></Link>Formation
      </Menu.Item>
      <Menu.Item key="competences">
        <Link to="/competences"></Link>Competences
      </Menu.Item>
      <Menu.Item key="experiences">
        <Link to="/experiences"></Link>Experience
      </Menu.Item>
      <Menu.Item key="realisation">
        <Link to="/realisation"></Link>Realisation
      </Menu.Item>
      <Menu.Item key="contact">
        <Link to="/contact"></Link>Contact
      </Menu.Item> */}
    </Menu>
  );
};

export default HeaderApp;
